<template>
  <div v-if="show" class="modal-overlay" @click.self="$emit('update:show', false)">
    <div class="manual-cost-modal">
      <h4 class="modal-title">✎ Ручная цена рейса</h4>
      <p class="modal-tip">
        {{ isAdmin ? 'Цена применится сразу.' : 'Запрос уйдёт на согласование руководителю.' }}
      </p>
      <label class="modal-field">
        <span class="modal-label">Цена без НДС</span>
        <input
          v-model="costWithoutNds"
          type="text"
          inputmode="decimal"
          placeholder="0,00"
          @input="onInput('without')"
        >
      </label>
      <label class="modal-field">
        <span class="modal-label">Цена с НДС</span>
        <input
          v-model="costWithNds"
          type="text"
          inputmode="decimal"
          placeholder="0,00"
          @input="onInput('with')"
        >
      </label>
      <p v-if="validationError" class="modal-error">{{ validationError }}</p>
      <label class="modal-field">
        <span class="modal-label">Комментарий (необязательно)</span>
        <textarea v-model="reason" rows="2"></textarea>
      </label>
      <div class="modal-actions">
        <button
          v-if="isAdmin && hasManualCost"
          class="operation-btn operation-danger"
          :disabled="loading"
          @click="onReset"
        >Сбросить</button>
        <button
          class="operation-btn operation-manual"
          :disabled="loading || Boolean(validationError)"
          @click="onApply"
        >Применить</button>
        <button
          class="operation-btn"
          :disabled="loading"
          @click="$emit('update:show', false)"
        >Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPriceField, parsePriceInput } from '@/pages/distribution/helpers';

export default {
  name: 'ManualCostEditModal',
  props: {
    show: { type: Boolean, default: false },
    order: { type: Object, default: () => ({}) },
    isAdmin: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  emits: ['update:show', 'apply', 'reset'],
  data() {
    return {
      costWithoutNds: '',
      costWithNds: '',
      reason: '',
    };
  },
  computed: {
    hasManualCost() {
      return this.order?.manual_cost != null || this.order?.manual_cost_nds != null;
    },
    parsedWithout() {
      return parsePriceInput(this.costWithoutNds);
    },
    parsedWith() {
      return parsePriceInput(this.costWithNds);
    },
    validationError() {
      if (this.parsedWithout == null && this.parsedWith == null) {
        return 'Укажите хотя бы одну цену';
      }
      if (this.parsedWithout != null && this.parsedWith != null && this.parsedWith < this.parsedWithout) {
        return 'Цена с НДС не может быть меньше цены без НДС';
      }
      if (this.parsedWithout != null && this.parsedWithout < 0) return 'Цена не может быть отрицательной';
      if (this.parsedWith != null && this.parsedWith < 0) return 'Цена не может быть отрицательной';
      return '';
    },
  },
  watch: {
    show(visible) {
      if (visible) this.prefill();
    },
  },
  methods: {
    prefill() {
      const without = this.order?.manual_cost ?? this.order?.embedded_route?.cost ?? null;
      const withNds = this.order?.manual_cost_nds ?? this.order?.embedded_route?.cost_nds ?? null;
      this.costWithoutNds = formatPriceField(without);
      this.costWithNds = formatPriceField(withNds);
      this.reason = this.order?.manual_cost_reason || '';
    },
    onInput() {
      // v-model handles state; parsePriceInput validates on submit
    },
    onApply() {
      if (this.validationError) return;
      const payload = {
        cost_without_nds: this.parsedWithout != null ? Math.round(this.parsedWithout) : null,
        cost_with_nds: this.parsedWith != null ? Math.round(this.parsedWith) : null,
      };
      const reason = (this.reason || '').trim();
      if (reason) payload.reason = reason;
      this.$emit('apply', payload);
    },
    onReset() {
      this.$emit('reset');
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.manual-cost-modal {
  width: 360px;
  max-width: 90vw;
  padding: 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}

.modal-title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.modal-tip {
  margin: 0 0 12px;
  font-size: 13px;
  color: #666;
}

.modal-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.modal-label {
  font-size: 13px;
  color: #555;
  font-weight: 600;
}

.manual-cost-modal input,
.manual-cost-modal textarea {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d7dce2;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
}

.modal-error {
  margin: 0 0 10px;
  font-size: 13px;
  color: #b83235;
  font-weight: 600;
}

.modal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.operation-btn {
  padding: 6px 10px;
  border: 1px solid #d7dce2;
  border-radius: 6px;
  background: #fff;
  color: #333;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.operation-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.operation-manual {
  background: #fff3cd;
  border-color: #ffe08a;
  color: #7a5b00;
}

.operation-danger {
  background: #fff0f0;
  border-color: #f5b5b5;
  color: #b83235;
}
</style>
